import deDE from "./de-DE.json";
import enUS from "./en-US.json";
import esES from "./es-ES.json";
import frFR from "./fr-FR.json";
import itIT from "./it-IT.json";
import jaJP from "./ja-JP.json";
import koKR from "./ko-KR.json";
import msMY from "./ms-MY.json";
import ptPT from "./pt-PT.json";
import ruRU from "./ru-RU.json";
import zhCN from "./zh-CN.json";
import zhHK from "./zh-HK.json";
export default {
  'de-DE': deDE,
  'en-US': enUS,
  'es-ES': esES,
  'fr-FR': frFR,
  'it-IT': itIT,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'ms-MY': msMY,
  'pt-PT': ptPT,
  'ru-RU': ruRU,
  'zh-CN': zhCN,
  'zh-HK': zhHK
};